/* global Swiper */
// *******************************************************************************
// 1.0 - Text image slider
// *******************************************************************************

window.addEventListener('spectoCmsContentLoaded', () => {
  window.articleSliderElements = document.querySelectorAll('[data-slider="detail-module-slider"]');

  window.articleSliderOptions = {
    slidesPerView: 1,
    spaceBetween: 12,
    speed: 600,
    watchOverflow: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  };

  articleSliderElements.forEach((el) => {
    const parent = el.closest('.detail-module__inner');
    const arrowRight = parent.querySelector('.swiper-button-next');
    const arrowLeft = parent.querySelector('.swiper-button-prev');
    const paginationElement = parent.querySelector('.swiper-pagination');

    articleSliderOptions.pagination.el = paginationElement;
    articleSliderOptions.navigation.nextEl = arrowRight;
    articleSliderOptions.navigation.prevEl = arrowLeft;

    // eslint-disable-next-line no-new
    new Swiper(el, articleSliderOptions);
  });

// *******************************************************************************

  window.progressBar = document.querySelector('.detail-module__progress-bar__color');
  if (progressBar) {
    const checkProgress = () => {
      const viewportHeight = document.body.clientHeight - window.innerHeight;
      const scrollPercent = (window.scrollY / viewportHeight) * 100;
      progressBar.style.width = `${scrollPercent}%`;
    };

    checkProgress();

    window.addEventListener('scroll', () => {
      checkProgress();
    });
  }
});
